import { Modal } from "@components";
import { useDocumentSignatureContext } from "@contexts";
import { styled, Link as MuiLink } from "@mui/material";
import { theme as OldTheme } from "../../../config";
import { onContactUsClick } from "@utils/index";
import { usePersistentCounter } from "@hooks";
import {
  failedSignatureWsp,
  UNKNOWN_SIGNATURE_ERROR_RETRIES_LIMIT,
} from "@constants/index";

const Link = styled(MuiLink)({
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "500",
  lineHeight: "23px",
  letterSpacing: "0.5px",
  color: OldTheme.pallete.text.link,
  cursor: "pointer",
});

interface Props {
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
}

export function UnknownDocumentSignatureErrorModal({
  onPrimaryAction,
  onSecondaryAction,
}: Props) {
  const { showUnknownErrorModal, setShowUnknownErrorModal } =
    useDocumentSignatureContext();

  const [
    unknownErrorRetries,
    setUnknownErrorRetries,
    resetUnknownErrorRetries,
  ] = usePersistentCounter("unknownSignatureErrorRetries", 0);

  const unknownErrorRetriesExhausted =
    unknownErrorRetries >= UNKNOWN_SIGNATURE_ERROR_RETRIES_LIMIT;

  return (
    <Modal
      title="Error al firmar la receta"
      content={
        unknownErrorRetriesExhausted ? (
          <>
            Por favor,{" "}
            <Link onClick={() => onContactUsClick(failedSignatureWsp)}>
              contáctanos
            </Link>{" "}
            para ayudarte.
          </>
        ) : (
          <>
            Por favor, intenta nuevamente. Si el error persiste,{" "}
            <Link onClick={() => onContactUsClick(failedSignatureWsp)}>
              contáctanos
            </Link>{" "}
            para ayudarte.
          </>
        )
      }
      isOpen={showUnknownErrorModal}
      buttonProps={
        unknownErrorRetriesExhausted
          ? undefined
          : {
              buttonText: "Reintentar",
              onClick: () => {
                setShowUnknownErrorModal(false);
                onPrimaryAction?.();
                setUnknownErrorRetries((prev) => prev + 1);
              },
            }
      }
      secondaryButtonProps={{
        buttonText: "Volver a inicio",
        onClick: () => {
          setShowUnknownErrorModal(false);
          onSecondaryAction?.();
          resetUnknownErrorRetries();
        },
      }}
    />
  );
}
